/* global Swiper */
const sliders = {
	el: {
		sliderContainer: document.querySelectorAll('.js-slider')
	},

	vars: {
		mediumAndUp: window.matchMedia('(min-width: 48em)'),
		extraLargeAndUp: window.matchMedia('(min-width: 80em)')
	},

	fxInitSlider(el) {
		const sliderCentered = el.dataset.sliderCentered ? JSON.parse(el.dataset.sliderCentered) : '',
			sliderDelay = el.dataset.sliderDelay ? JSON.parse(el.dataset.sliderDelay) : '',
			sliderLoop = el.dataset.sliderLoop ? JSON.parse(el.dataset.sliderLoop) : '',
			sliderAutoPlay = el.dataset.sliderAutoplay ? JSON.parse(el.dataset.sliderAutoplay) : '',
			sliderSizeWide = el.dataset.sliderWide ? JSON.parse(el.dataset.sliderWide) : '',
			sliderSizeLarge = el.dataset.sliderLarge ? JSON.parse(el.dataset.sliderLarge) : '',
			sliderSizeMedium = el.dataset.sliderMedium ? JSON.parse(el.dataset.sliderMedium) : '',
			sliderSizeSmall = el.dataset.sliderSmall ? JSON.parse(el.dataset.sliderSmall) : '',
			sliderPaginationType = el.dataset.sliderPaginationType ? el.dataset.sliderPaginationType : '',
			sliderSpaceBetween = el.dataset.sliderSpaceBetween ? JSON.parse(el.dataset.sliderSpaceBetween) : '',
			sliderOnInteraction = el.dataset.sliderOnInteraction ? JSON.parse(el.dataset.sliderOnInteraction) : '',
			sliderNoSwipe = el.dataset.sliderNoSwipe ? JSON.parse(el.dataset.sliderNoSwipe) : '',
			sliderFreeMode = el.dataset.sliderFreemode ? JSON.parse(el.dataset.sliderFreemode) : '',
			sliderFreeModeSticky = el.dataset.sliderFreemodeSticky ? JSON.parse(el.dataset.sliderFreemodeSticky) : '',
			sliderKeyboard = el.dataset.sliderKeyboard ? JSON.parse(el.dataset.sliderKeyboard) : '',
			sliderMouseWheel = el.dataset.sliderMousewheel ? JSON.parse(el.dataset.sliderMousewheel) : '',
			sliderScroll = el.dataset.sliderScroll ? JSON.parse(el.dataset.sliderScroll) : '',
			sliderSpeed = el.dataset.sliderSpeed ? JSON.parse(el.dataset.sliderSpeed) : '',
			slidesPerGroup = el.dataset.sliderGroup ? JSON.parse(el.dataset.sliderGroup) : '',
			slidesPerColumn = el.dataset.sliderColumn ? JSON.parse(el.dataset.sliderColumn) : ''

		const slider = new Swiper(el, {
			slidesPerView: sliderSizeSmall ? sliderSizeSmall : 1,
			centeredSlides: sliderCentered ? sliderCentered : false,
			loop: sliderLoop ? sliderLoop : false,
			spaceBetween: sliderSpaceBetween ? sliderSpaceBetween : 0,
			noSwiping: sliderNoSwipe ? sliderNoSwipe : false,
			speed: sliderSpeed ? sliderSpeed : 300,
			freeMode: sliderFreeMode ? sliderFreeMode : false,
			freeModeSticky: sliderFreeMode && sliderFreeModeSticky ? sliderFreeModeSticky : false,
			slideToClickedSlide: sliderFreeMode ? true : false,
			slidesPerGroup: slidesPerGroup ? slidesPerGroup : 1,
			slidesPerColumn: slidesPerColumn ? slidesPerColumn : 1,
			threshold: el.closest('.slider-quote') ? 10000 : 0,
			watchOverflow: true,
			mousewheel: sliderFreeMode ? {
				releaseOnEdges: true
			} : sliderMouseWheel ? sliderMouseWheel : false,

			keyboard: {
				enabled: sliderKeyboard ? sliderKeyboard : false
			},

			navigation: {
				nextEl: el.closest('.slider-quote') ? '.js-slider-next' : el.querySelector('.swiper-button-next'),
				prevEl: el.closest('.slider-quote') ? '.js-slider-prev' : el.querySelector('.swiper-button-prev')
			},

			pagination: {
				el: el.querySelector('.swiper-pagination'),
				clickable: sliderPaginationType ? false : true,
				type: sliderPaginationType ? sliderPaginationType : 'bullets' //"bullets", "fraction", "progressbar" or "custom"  (default:"bullets")
			},

			scrollbar: {
				el: sliderScroll ? sliderScroll : null,
				hide: sliderScroll && true
			},

			autoplay: sliderAutoPlay === true ? {
				delay: sliderDelay ? sliderDelay : 5000,
				disableOnInteraction: sliderOnInteraction ? sliderOnInteraction : false
			} : false,

			breakpoints: {
				768: { //tablet up
					slidesPerView: sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				},
				1280: { //small desktop up
					slidesPerView: sliderSizeLarge ? sliderSizeLarge : sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				},
				1440: { // desktop up
					slidesPerView: sliderSizeWide ? sliderSizeWide : sliderSizeLarge ? sliderSizeLarge : sliderSizeMedium ? sliderSizeMedium : sliderSizeSmall ? sliderSizeSmall : 1
				}
			},

			on: {
				init: () => setTimeout(() => {
					window.dispatchEvent(new Event('resize'))
					if (el.querySelector('.swiper-slide-active .js-video') && el.querySelector('.swiper-slide-active .js-video').classList.contains('js-autoplay')) {
						slider.autoplay.stop()
						el.querySelector('.js-autoplay video').load()
					}
					else {
						slider.autoplay.start()
					}
				}, 100),

				slideChange: () => {
					if (el.querySelector('.js-video')) {
						el.closest('.slider-hero') && el.closest('.slider-hero').classList.contains('hidden-progress-bar') && el.closest('.slider-hero').classList.remove('hidden-progress-bar')
						el.querySelectorAll('.js-video').forEach(el => {
							const videoPlayer = el.querySelector('video')
							const progressBar = el.querySelector('.js-video-seekbar')
							progressBar.value = 0
							videoPlayer.pause()
							videoPlayer.currentTime = 0
							videoPlayer.muted = true
							videoPlayer.closest('.swiper-slide').classList.remove('video-is-playing')
							videoPlayer.parentElement.querySelector('.js-video-play').classList.contains('is-playing') && videoPlayer.parentElement.querySelector('.js-video-play').classList.remove('is-playing')
							videoPlayer.parentElement.querySelector('.js-video-sound').classList.contains('has-sound') && videoPlayer.parentElement.querySelector('.js-video-sound').classList.remove('has-sound')
						})
						setTimeout(() => {
							if (el.querySelector('.swiper-slide-active .js-video') && el.querySelector('.swiper-slide-active .js-video').classList.contains('js-autoplay')) {
								slider.autoplay.stop()
								el.querySelector('.js-autoplay video').load()
							}
							else {
								slider.autoplay.start()
							}
						}, 100)
					}
				},

				transitionStart: () => {
					if (this.vars.extraLargeAndUp.matches && el.parentElement.classList.contains('slider-media__grid'))
						el.querySelector('.slider-media__thumb').style.display = 'none'
				},

				transitionEnd: () => {
					if (this.vars.extraLargeAndUp.matches && el.parentElement.classList.contains('slider-media__grid') && !el.swiper.slides[el.swiper.slides.length - 1].classList.contains('swiper-slide-active')) {

						const nextSlide = el.querySelector('.swiper-slide-next'),
							nextSlideTitle = nextSlide.querySelector('.beta').innerHTML,
							nextSlideImage = nextSlide.querySelector('.slider-media__image').src

						el.querySelector('.slider-media__thumb').style.display = 'flex'
						el.querySelector('.slider-media__thumb-heading').innerHTML = nextSlideTitle
						el.querySelector('.slider-media__thumb-image').src = nextSlideImage
					}
				},

				reachEnd: () => {
					if (this.vars.extraLargeAndUp.matches && el.parentElement.classList.contains('slider-media__grid')) {
						setTimeout(() => {
							const nextSlide = el.querySelector('[data-swiper-slide-index="1"]'),
								nextSlideTitle = nextSlide.querySelector('.beta').innerHTML,
								nextSlideImage = nextSlide.querySelector('.slider-media__image').src

							el.querySelector('.slider-media__thumb').style.display = 'flex'
							el.querySelector('.slider-media__thumb-heading').innerHTML = nextSlideTitle
							el.querySelector('.slider-media__thumb-image').src = nextSlideImage
						}, 300)
					}
				},

				resize: () => !this.vars.extraLargeAndUp.matches && document.querySelector('.slider-media__thumb') ? document.querySelector('.slider-media__thumb').style.display = 'none' : ''

			}
		})

		if (!document.querySelector('.js-next-slide')) return
		document.querySelector('.js-next-slide').addEventListener('click', () => slider.slideNext())
	},

	init() {
		this.el.sliderContainer.forEach(el => {
			if (el.querySelectorAll('.swiper-slide').length === 1) {
				if (el.closest('.slider-hero')) {
					el.querySelector('.slider-hero__nav-pagination').classList.add('d-none')
					el.closest('.slider-hero').classList.add('hidden-progress-bar')
				}
				if (el.closest('.slider-media')) {
					el.querySelector('.slider-media__thumb').classList.add('d-none')
					el.querySelector('.slider-media__nav-pagination').classList.add('d-none')
					el.querySelector('.slider-media__container').classList.add('hidden-progress-bar')
				}
				el.closest('.slider-quote') && el.querySelector('.slider-quote__navigation') && el.querySelector('.slider-quote__navigation').classList.add('d-none')
			}
			else
				this.fxInitSlider(el)
		})

	}
}
sliders.init()